export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';

export const toggleFullscreen = () => ({
  type: TOGGLE_FULLSCREEN,
});
